//CHECK_IN_DOWNLOAD_REPORT
export const CHECK_IN_DOWNLOAD_REPORT_REQUEST =
  "CHECK_IN_DOWNLOAD_REPORT_REQUEST";
export const CHECK_IN_DOWNLOAD_REPORT_SUCCESS =
  "CHECK_IN_DOWNLOAD_REPORT_SUCCESS";
export const CHECK_IN_DOWNLOAD_REPORT_FAIL = "CHECK_IN_DOWNLOAD_REPORT_FAIL";

//GET_DOWNLOADED_REPORTS
export const GET_DOWNLOADED_REPORTS_REQUEST = "GET_DOWNLOADED_REPORTS_REQUEST";
export const GET_DOWNLOADED_REPORTS_SUCCESS = "GET_DOWNLOADED_REPORTS_SUCCESS";
export const GET_DOWNLOADED_REPORTS_FAIL = "GET_DOWNLOADED_REPORTS_FAIL";

//UPDATE_DOWNLOAD_HISTORY
export const UPDATE_DOWNLOAD_HISTORY_REQUEST =
  "UPDATE_DOWNLOAD_HISTORY_REQUEST";
export const UPDATE_DOWNLOAD_HISTORY_SUCCESS =
  "UPDATE_DOWNLOAD_HISTORY_SUCCESS";
export const UPDATE_DOWNLOAD_HISTORY_FAIL = "UPDATE_DOWNLOAD_HISTORY_FAIL";
